import { render, staticRenderFns } from "./ControlsContainer.vue?vue&type=template&id=5e37f4bc&scoped=true&"
import script from "./ControlsContainer.vue?vue&type=script&lang=js&"
export * from "./ControlsContainer.vue?vue&type=script&lang=js&"
import style0 from "./ControlsContainer.vue?vue&type=style&index=0&id=5e37f4bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e37f4bc",
  null
  
)

export default component.exports